<template>
    <div>
        <div class="banner">
            <div class="headerReplacementBasicInfo"></div>
            <div class="banner-text">
                <h4><b>ORI - แจ้งสิทธิและรายละเอียดการจองซื้อหุ้นสามัญเพิ่มทุน</b></h4>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span>ข้อมูลผู้ถือหุ้น</span>
                    <span class="separator"></span>
                    <span><b>ORI - แจ้งสิทธิและรายละเอียดการจองซื้อหุ้นสามัญเพิ่มทุน</b></span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="TabMenu">
                <BasicInfoTabMenu />
            </div>

            <table class="table mb-5">
                <thead>
                    <tr class="table-secondary">
                        <th scope="col"><b>ข้อมูลเอกสาร</b></th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                        <td> {{ item.notification_name }}</td>
                        <td class="text-end">
                            <a :href="item.notification_url" target="_blank" class="text-decoration-none">
                                <p class="card-text text-secondary">
                                    <small class="text-muted">
                                        <i class="fa-solid fa-download"></i> ดาวน์โหลด
                                    </small>
                                </p>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- Loading Spinner (Centered) -->
            <div v-if="isLoading" class="d-flex justify-content-center align-items-center mb-5" style="height: 50px;">
                <div class="spinner-grow custom-spinner" role="status"></div>
            </div>
        </div>
    </div>
</template>
<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import store from "@/store";
import { GET_NOTIFICATION_DATA } from "../../store/actions.type";

export default {
    name: 'MajorShareholders',
    components: {
        BasicInfoTabMenu,
    },
    data() {
        return {
            list: [],
            isLoading: false,
        };
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    methods: {
        async init() {
            this.list = await store.dispatch(GET_NOTIFICATION_DATA);
        },


    },
}
</script>
